@for (hint of $hints(); track hint.text; let isLast = $last) {
  <span class="hint-text">{{ hint.text }}</span>
  @if (!isLast) {
    <span class="hint-separator" aria-hidden="true"></span>
  }
}
